import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
    state: {
        jwt: null,
        expire: null,
        fields: [],
        items: [],
        vendors: [],
        customers: [],
        uoms: [],
        branchs: [],
        filter: {
            Text: '',
            IsFilterDate: true,
            Page: 1,
            Total: 0,
            Limit: 25
        },
        routenum: 0,
        accounts: [],
        userGroup: 0,
        company: {}
    },
    mutations: {
        updateUserGroup(state, n){
            if(n == 'Marketing'){
                state.userGroup = 0;
            }else state.userGroup = 1;
        },
        updateCompany(state, v) {
            if (v != null) state.company = v;
        }
    }
});

export { store };